import axios from 'axios';
import humps from 'humps';
import isNode from 'detect-node';
import Agent from 'agentkeepalive';
import {X_VUP_ORIGIN_HEADER_NAME} from './consts';

let axiosInstance;
if (isNode) {
  const keepAliveAgent = new Agent({
    maxSockets: 100,
    maxFreeSockets: 10,
    timeout: 60000, // active socket keepalive for 60 seconds
    freeSocketTimeout: 30000, // free socket keepalive for 30 seconds
  });
  axiosInstance = axios.create({httpAgent: keepAliveAgent});
} else {
  axiosInstance = axios.create();
}

const instance = axiosInstance;
instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.patch['Content-Type'] = 'application/json';
instance.defaults.headers.put['Content-Type'] = 'application/json';

instance.interceptors.request.use((request) => {
  if (request.data) {
    request.data = JSON.stringify(humps.decamelizeKeys(request.data));
  }
  if (request.params) {
    request.params = humps.decamelizeKeys(request.params);
  }
  return request;
});

instance.interceptors.response.use((response) => {
  if (response.data) {
    return humps.camelizeKeys(response.data);
  }
});

/**
 * HTTP Origin headers are used to differentiate request pools in server LB
 */
instance.setVupOriginHttpHeader = (value) => {
  instance.defaults.headers.common[X_VUP_ORIGIN_HEADER_NAME] = value;
};

/**
 * HTTP Origin headers are used to differentiate request pools in server LB
 */
instance.overrideVupOriginHttpHeader = (value) => {
  instance.originalVupOriginHttpHeader = instance.defaults.headers.common[X_VUP_ORIGIN_HEADER_NAME];
  instance.setVupOriginHttpHeader(value);
};

/**
 * HTTP Origin headers are used to differentiate request pools in server LB
 */
instance.revertVupOriginHttpHeader = () => {
  if (instance.originalVupOriginHttpHeader) {
    instance.setVupOriginHttpHeader(instance.originalVupOriginHttpHeader);
  } else {
    delete instance.defaults.headers.common[X_VUP_ORIGIN_HEADER_NAME];
  }
};

export default instance;
